document.addEventListener('DOMContentLoaded', () => {
  const popups = document.querySelectorAll('[data-nido-popup]');

  popups.forEach((popup) => {
    const dismissedKey = 'nido-popup-dismissed';
    const hasDismissedPopup = () => {
  return document.cookie
    .split('; ')
    .some((cookie) => cookie === `${dismissedKey}=true`);
};

const rememberPopupDismissal = () => {
  document.cookie = `${dismissedKey}=true; path=/; SameSite=Lax`;
};
    const delay = Number(popup.dataset.delay || 0);
    const steps = popup.querySelectorAll('[data-nido-step]');
    const progress = popup.querySelector('[data-nido-progress]');
    const momentInputs = popup.querySelectorAll('[data-nido-moment]');
    const ownResultButton = popup.querySelector('[data-nido-own-result]');

    const state = {
      recipient: '',
      age: '',
      occasion: '',
      giftAge: '',
      moments: []
    };

    const showStep = (stepName) => {
      steps.forEach((step) => {
        const isActive = step.dataset.nidoStep === stepName;
        step.hidden = !isActive;
        step.classList.toggle('is-active', isActive);
      });

      updateProgress(stepName);
    };

    const updateProgress = (stepName) => {
      if (!progress) return;

      const progressMap = {
        welcome: 15,
        recipient: 30,
        'own-age': 50,
        moments: 70,
        'own-result': 100,
        'gift-occasion': 50,
        'gift-age': 70,
        'gift-result': 100
      };

      progress.style.width = `${progressMap[stepName] || 15}%`;
    };

   const openPopup = () => {
  if (hasDismissedPopup()) return;

  popup.classList.add('is-visible');
  popup.setAttribute('aria-hidden', 'false');
  document.body.classList.add('nido-popup-open');
  showStep('welcome');
};

   const closePopup = () => {
  rememberPopupDismissal();

  popup.classList.remove('is-visible');
  popup.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('nido-popup-open');
};
   const createOwnResult = () => {
  const resultContainer = popup.querySelector(
    '[data-nido-personalized-result]'
  );

  if (!resultContainer) return;

  const ageIntroTemplate = popup.querySelector(
    `[data-nido-age-intro="${state.age}"]`
  );

  const ageIntro = ageIntroTemplate
    ? `<div class="nido-popup-age-intro">
        ${ageIntroTemplate.innerHTML}
      </div>`
    : '';

  const selectedTexts = state.moments
    .map((moment) => {
      const template = popup.querySelector(
        `[data-nido-text="${state.age}_${moment}"]`
      );

      if (!template) return '';

      return `<div class="nido-popup-result-item">
        ${template.innerHTML}
      </div>`;
    })
    .filter(Boolean);

  resultContainer.innerHTML =
    ageIntro + selectedTexts.join('');
};
const createGiftResult = () => {
  const resultContainer = popup.querySelector(
    '[data-nido-gift-personalized-result]'
  );

  if (!resultContainer) return;

  const giftAgeIntroTemplate = popup.querySelector(
    `[data-nido-gift-age-intro="${state.giftAge}"]`
  );

  const giftAgeIntro = giftAgeIntroTemplate
    ? `<div class="nido-popup-age-intro">
        ${giftAgeIntroTemplate.innerHTML}
      </div>`
    : '';

  const giftTextTemplate = popup.querySelector(
    `[data-nido-gift-text="${state.occasion}_${state.giftAge}"]`
  );

  const giftText = giftTextTemplate
    ? `<div class="nido-popup-result-item">
        ${giftTextTemplate.innerHTML}
      </div>`
    : '';

  resultContainer.innerHTML = giftAgeIntro + giftText;
};
    popup.querySelectorAll('[data-nido-next]').forEach((button) => {
  button.addEventListener('click', () => {
    const nextStep = button.dataset.nidoNext;
    if (button.dataset.nidoRecipient) {
  state.recipient = button.dataset.nidoRecipient;
}

if (button.dataset.nidoAge) {
  state.age = button.dataset.nidoAge;
}

if (button.dataset.nidoOccasion) {
  state.occasion = button.dataset.nidoOccasion;
}

if (button.dataset.nidoGiftAge) {
  state.giftAge = button.dataset.nidoGiftAge;
}

    if (nextStep === 'gift-result') {
      createGiftResult();
     rememberPopupDismissal();
    }

    showStep(nextStep);
  });
});

    popup.querySelectorAll('[data-nido-back]').forEach((button) => {
      button.addEventListener('click', () => {
        showStep(button.dataset.nidoBack);
      });
    });

    popup.querySelectorAll('[data-nido-close]').forEach((button) => {
      button.addEventListener('click', closePopup);
    });

    popup.querySelectorAll('[data-nido-recipient]').forEach((button) => {
      button.addEventListener('click', () => {
        state.recipient = button.dataset.nidoRecipient;
      });
    });

    popup.querySelectorAll('[data-nido-age]').forEach((button) => {
      button.addEventListener('click', () => {
        state.age = button.dataset.nidoAge;
      });
    });

    popup.querySelectorAll('[data-nido-occasion]').forEach((button) => {
      button.addEventListener('click', () => {
        state.occasion = button.dataset.nidoOccasion;
      });
    });

    popup.querySelectorAll('[data-nido-gift-age]').forEach((button) => {
      button.addEventListener('click', () => {
        state.giftAge = button.dataset.nidoGiftAge;
      });
    });

    momentInputs.forEach((input) => {
      input.addEventListener('change', () => {
        state.moments = Array.from(momentInputs)
          .filter((item) => item.checked)
          .map((item) => item.value);

        if (ownResultButton) {
          ownResultButton.disabled = state.moments.length === 0;
        }
      });
    });

    if (ownResultButton) {
     ownResultButton.addEventListener('click', () => {
  createOwnResult();
 rememberPopupDismissal();
  showStep('own-result');
});
    }

    popup.addEventListener('click', (event) => {
      if (event.target === popup) {
        closePopup();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closePopup();
      }
    });

    window.setTimeout(openPopup, delay);
  });
});